import { useState } from 'react'
import { Dialog } from 'radix-ui'
import { Combobox } from '@/components/common/Combobox'
import { useUpdateBoardColumn } from '../hooks'
import type { BoardColumnDto, TaskStatus } from '../types'

interface EditColumnDialogProps {
  boardId: number
  column: BoardColumnDto
  onClose: () => void
}

const STATUS_LABELS: Record<TaskStatus, string> = {
  NEW: 'Nowe',
  IN_PROGRESS: 'W toku',
  DONE: 'Gotowe',
  CANCELLED: 'Anulowane',
}

export function EditColumnDialog({ boardId, column, onClose }: EditColumnDialogProps) {
  const update = useUpdateBoardColumn(boardId)
  const [name, setName] = useState(column.name)
  const [defaultStatus, setDefaultStatus] = useState<TaskStatus>(column.defaultStatus)

  const submit = () => {
    if (!name.trim()) return
    update.mutate(
      {
        columnId: column.id,
        patch: { name: name.trim(), defaultStatus },
      },
      { onSuccess: onClose },
    )
  }

  return (
    <Dialog.Root open onOpenChange={(o) => { if (!o) onClose() }}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/40" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg p-5 w-[400px] shadow-xl">
          <Dialog.Title className="text-base font-semibold">Edytuj kolumnę</Dialog.Title>
          <div className="mt-4 flex flex-col gap-3 text-sm">
            <label className="grid gap-1">
              <span className="text-xs uppercase text-slate-500">Nazwa</span>
              <input
                autoFocus
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="border rounded px-2 py-1"
              />
            </label>
            <div className="grid gap-1">
              <span className="text-xs uppercase text-slate-500">Domyślny status</span>
              <Combobox<TaskStatus>
                value={defaultStatus}
                onChange={(v) => { if (v) setDefaultStatus(v) }}
                options={(Object.keys(STATUS_LABELS) as TaskStatus[]).map((s) => ({
                  value: s,
                  label: `${STATUS_LABELS[s]} (${s})`,
                }))}
                placeholder="Wybierz status..."
              />
            </div>
            <div className="flex justify-end gap-2 mt-2">
              <button onClick={onClose} className="px-3 py-1 text-sm border rounded">Anuluj</button>
              <button
                onClick={submit}
                disabled={!name.trim() || update.isPending}
                className="px-3 py-1 text-sm bg-sky-600 text-white rounded disabled:opacity-50"
              >
                Zapisz
              </button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
